module.exports = __webpack_public_path__ + "img/galeria_06.e9a92c66.jpg";